var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "group-template" },
    _vm._l(_vm.list, function (item, index) {
      return _c(
        "div",
        {
          key: "template" + item.templateNum,
          staticClass: "template-item",
          class: "template" + item.templateNum,
        },
        [
          _c(
            "div",
            { staticClass: "template-content", attrs: { title: "预览模板" } },
            [
              _c("el-image", {
                staticStyle: { width: "100%", height: "100%" },
                attrs: {
                  src: item.picUrl,
                  fit: "scale-down",
                  "preview-src-list": [item.picUrl],
                },
              }),
              _c("span", { staticClass: "el-icon-search" }),
            ],
            1
          ),
          _c(
            "p",
            { staticClass: "template-radio" },
            [
              _c(
                "el-radio",
                {
                  attrs: { label: item.templateNum },
                  model: {
                    value: _vm.form.templateNum,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "templateNum", $$v)
                    },
                    expression: "form.templateNum",
                  },
                },
                [
                  item.templateNum === 1
                    ? _c("span", [_vm._v("主模板")])
                    : item.templateNum === 2
                    ? _c("span", [_vm._v("副模板")])
                    : _c("span", [_vm._v("多模板" + _vm._s(index + 1))]),
                ]
              ),
            ],
            1
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }